export const Insurer = {
    Uniqa: 1,
    Kooperativa: 2,
    Allianz: 3,
    Generali: 4,
    CPP: 5,
    GeneraliCeskaPojistovna: 6,
    Direct: 7,
    Csob: 8,
    Axa: 9,
    Slavia: 10,
    HvP: 11,
    PVZP: 12,
    Fortegra: 13,
    Pillow: 14,
    EuropAssistance: 15,
    Colonnade: 16,
    AxaAssistance: 17,
    Das: 18,
    Custom: 19,
    AllianzSP: 20,
    GeneraliSK: 21,
    KB: 22,
    SV: 23,
}

export type Insurer = typeof Insurer[keyof typeof Insurer]

export const getInsurerName = (insurer: Insurer | undefined): string | undefined => {
    switch (insurer) {
        case Insurer.Uniqa:
            return 'Uniqa'
        case Insurer.Kooperativa:
            return 'Kooperativa'
        case Insurer.Allianz:
            return 'Allianz'
        case Insurer.Generali:
            return 'Generali'
        case Insurer.CPP:
            return 'Česká podnikatelská pojišťovna'
        case Insurer.GeneraliCeskaPojistovna:
            return 'Generali Česká pojišťovna'
        case Insurer.Direct:
            return 'Direct'
        case Insurer.Csob:
            return 'ČSOB Pojišťovna'
        case Insurer.Axa:
            return 'AXA'
        case Insurer.Slavia:
            return 'Slavia pojišťovna'
        case Insurer.HvP:
            return 'Hasičská vzájemná pojišťovna'
        case Insurer.PVZP:
            return 'Pojišťovna VZP'
        case Insurer.Fortegra:
            return 'Fortegra pojišťovna'
        case Insurer.Pillow:
            return 'Pillow pojištění'
        case Insurer.EuropAssistance:
            return 'Europ Assistance'
        case Insurer.Colonnade:
            return 'Colonnade Insurance S.A.'
        case Insurer.AxaAssistance:
            return 'AXA Assistance'
        case Insurer.Das:
            return 'D.A.S.'
        case Insurer.AllianzSP:
            return 'Allianz Slovenská poisťovňa'
        case Insurer.GeneraliSK:
            return 'Generali Slovensko'
        case Insurer.KB:
            return 'KB Pojišťovna'
        case Insurer.SV:
            return 'SV Pojišťovna'
        default:
            return undefined
    }
}

export interface IOfferCompany {
    id: number
    name: string
}